var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sa-container",attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.isRinging)?_c('ringer'):_vm._e(),_vm._v(" "),(_vm.inCall)?_c('video-call-view'):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"sa-loader-bg"},[_c('img',{staticClass:"sa-loader",attrs:{"src":"/static/img/loader.svg","alt":"loader"}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-524b3843","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 